/**
 * @file Discover album folder start for the Camps vertical.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import DiscoverAlbumFolderStartCampParentPay from './DiscoverAlbumFolderStartCampParentPay';
import DiscoverAlbumFolderStartCampParentPayCharity from './DiscoverAlbumFolderStartCampParentPayCharity';
import DiscoverAlbumFolderStartCampPay from './DiscoverAlbumFolderStartCampPay';
import {
  albumFolderHasCharity,
  albumFolderHasFreeTrial,
  albumFolderIsPrePaid,
} from '../../../util/album-folder';
import DiscoverAlbumFolderStartCampFreeTrial from './DiscoverAlbumFolderStartCampFreeTrial';
import getConfig from '../../../util/config';
import LogoPoweredBy from '../../global/LogoPoweredBy';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    has_charity: PropTypes.bool,
    charity_description: PropTypes.string,
    is_demo: PropTypes.bool,
    has_free_trial: PropTypes.bool,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func.isRequired,
};

const DiscoverAlbumFolderStartCamps = ({ albumFolder, onGetStarted }) => {
  const hasCharity = albumFolderHasCharity(albumFolder);
  const isPrePaid = albumFolderIsPrePaid(albumFolder);
  const isPictureDay = !!albumFolder?.picture_day_enabled;
  const hasFreeTrial = albumFolderHasFreeTrial(albumFolder);
  const config = getConfig();

  if (isPrePaid) {
    return (
      <Fragment>
        <DiscoverAlbumFolderStartCampPay
          albumFolder={albumFolder}
          onGetStarted={onGetStarted}
        />
        <a
          href={config.marcomUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="discovery-start-logo"
        >
          <LogoPoweredBy />
        </a>
      </Fragment>
    );
  }

  if (hasCharity && !isPictureDay) {
    return (
      <Fragment>
        <DiscoverAlbumFolderStartCampParentPayCharity
          albumFolder={albumFolder}
          onGetStarted={onGetStarted}
        />
        <a
          href={config.marcomUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="discovery-start-logo"
        >
          <LogoPoweredBy />
        </a>
      </Fragment>
    );
  }

  if (hasFreeTrial) {
    return (
      <Fragment>
        <DiscoverAlbumFolderStartCampFreeTrial
          albumFolder={albumFolder}
          onGetStarted={onGetStarted}
        />
        <a
          href={config.marcomUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="discovery-start-logo"
        >
          <LogoPoweredBy />
        </a>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <DiscoverAlbumFolderStartCampParentPay
        albumFolder={albumFolder}
        onGetStarted={onGetStarted}
      />
      <a
        href={config.marcomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="discovery-start-logo"
      >
        <LogoPoweredBy />
      </a>
    </Fragment>
  );
};

DiscoverAlbumFolderStartCamps.propTypes = propTypes;

export default DiscoverAlbumFolderStartCamps;
